import React from "react";
import styled from "styled-components";
import { COLOR_SYSTEM } from "components/atoms";

interface AdminGroundTruthTemplateProps {
  children: React.ReactNode;
}

const AdminGroundTruthTemplate: React.FC<AdminGroundTruthTemplateProps> = ({ children }) => {
  return (
    <Container>
      <Content>{children}</Content>
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
  background-color: ${COLOR_SYSTEM.get("Gray")[0]};
`;

const Content = styled.div`
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
`;

export default AdminGroundTruthTemplate;
